// import React from 'react';
import {asyncGetIp, getDate, makeid, asyncToString, boolToInt} from './Logging-Utility'


import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth, signInAnonymously, onAuthStateChanged  } from "firebase/auth";
import { addDoc, collection, getFirestore, setDoc, doc, getDoc  } from "firebase/firestore"; 
import { getStorage, ref, uploadBytes, getDownloadURL, getBlob } from "firebase/storage";

import React from 'react';
import { useState } from 'react';

// const firebase = window.firebase;


const firebaseConfig = {
    apiKey: "AIzaSyB_kPYFr59HdnkLYYe5H-LZBtMOGPcG-2s",
    authDomain: "imagewall-v2.firebaseapp.com",
    projectId: "imagewall-v2",
    storageBucket: "imagewall-v2.appspot.com",
    messagingSenderId: "680566564085",
    appId: "1:680566564085:web:b4139cb3097164e9db91bc",
    measurementId: "G-J869KB54ML"
}

let uid


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

//Authentication
// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
// let signedIn = false;
async function signInAnonymouslyAndGetUID() {
    try {
      const userCredential = await signInAnonymously(auth);
      const user = userCredential.user;
      uid = user.uid;
      console.log('Signed in..', user);
      console.log('Signed in..', uid);
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error('Error:', errorCode, errorMessage);
    }
  }

  signInAnonymouslyAndGetUID()


// onAuthStateChanged(auth, (user) => {
//     console.log('user', user);
//     if (user) {
//         // User is signed in, see docs for a list of available properties
//         // https://firebase.google.com/docs/reference/js/firebase.User

//         console.log('user', user);
//         // uid = user.uid;
//         // ...
//     } else {
//         // User is signed out
//         // ...
//         console.log('user signed out');
//     }
// });


// uid = auth.user.uid

// Log an analytics event

logEvent(analytics, 'page_view', {
    page_title: 'ImageWall',
    page_location: 'https://imagewall-v2.web.app/',
    page_path: '/'
  });

console.log('firebaseRealtime.js', auth);


//fix for Json replace variables
let counter = 0
let initTimeStamp = getDate().timeStamp;


//sudo unique ID for session
const uniquId =  makeid(10);
//I think this might need to be generated as a state variable.  Maybe with UseRef() and UseEffect to run the operation once?  
// Don't know for certain since it seems to work, 
// but at the same time, i'm not sure how to place it so that it's accessible for console logging or as a hidden variable. 
console.log('uniquId', uid);
// storage implementation

// Get a reference to the Firebase Storage bucket
const storage = getStorage(app);

// Function to upload a Blob to Firebase Storage and get the download URL
async function uploadBlobToStorage(blob, path) {
  const storageRef = ref(storage, path);
  
  try {
    // Upload the blob to the specified path
    await uploadBytes(storageRef, blob);
    
    // Get the download URL for the uploaded file
    const downloadURL = await getDownloadURL(storageRef);
    
    return downloadURL;
  } catch (error) {
    console.error("Error uploading blob to Firebase Storage:", error);
    return null;
  }
}

async function  restoreConfigFromFirebase (hascode){
  // const storageRef = ref(storage, "CaptureDownload/" + path);
  const docRef = doc(db, "CaptureDownload/" + hascode);
  const docSnap = await getDoc(docRef);
    // console.log('storageRef', docSnap.data());
    return docSnap.data();

}

async function urlToBlob(url) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error fetching the image:", error);
    return null;
  }
}

function blobToFile(blob, fileName) {
  const options = { type: blob.type };
  const date = new Date();
  const lastModified = date.getTime();
  return new File([blob], fileName, { type: blob.type, lastModified });
}

function downloadBlob(blob, name = "file.txt") {
  
    // Create a blob URL.
  const blobUrl = URL.createObjectURL(blob);

  // Create a link element.
  const downloadLink = document.createElement('a');

  // Set the href attribute to the blob URL.
  downloadLink.href = blobUrl;

  // Set the download attribute to specify the filename.
  downloadLink.download = 'image.jpg'; // Change 'image.jpg' to your desired filename.

  // Programmatically trigger a click event to start the download.
  downloadLink.click();

  // Clean up the blob URL when you're done (optional).
  URL.revokeObjectURL(blobUrl);
}

async function getImageFromFirebaseStorage(path) {
  const storageRef = ref(storage, "images/" + path + "_Original.png");
  // console.log('storageRef', storageRef);

  const imageBlob = await getBlob(storageRef)
  // downloadBlob(imageBlob, "image.png")
  // const downloadURL = await getDownloadURL(storageRef)

  // const imageBlob = await fetch(downloadURL)

  const imageBlobFile =  blobToFile(imageBlob, "image.png")
 
  return imageBlobFile;
  }

async function asyncLogParams(name, value, DataOutputs = '') {

    console.log('asyncLogParams');
    let {ymdDate, timeStamp } = getDate();
    let valueCleaned = boolToInt(value);
    // console.log(valueCleaned);
    // userIp = '136-55-777-44'
    //get user IP and format to nice string
    let actionId = initTimeStamp + "_" + counter//await asyncGetIp();
    let userIp = ""//await asyncToString(temp);
    


    let docRef
    console.log('uid, DataOutputs.ProjectName', name, value, DataOutputs);

    // try {
    if (name === "CaptureDownload"){
        console.log('CaptureDownload', DataOutputs.ProjectName, uid);
        // const docRef = await addDoc(collection(db, uid), {
         docRef = await setDoc(doc(db, "CaptureDownload",  DataOutputs.ProjectName), {
            "user": uid,
            "IP": userIp || "No IP", // default to "No IP" if userIp is undefined
            "name": name || "No Name", // default to "No Name" if name is undefined
            "value": valueCleaned,
            "Counter": counter,
            "Date": ymdDate,
            "timeStamp": timeStamp,
            "DataOutputs": DataOutputs
        });
        docRef = await setDoc(doc(db, "users",  uid, "actions", actionId), {
                  "IP": userIp || "No IP", // default to "No IP" if userIp is undefined
                  "name": name || "No Name", // default to "No Name" if name is undefined
                  "value": valueCleaned,
                  "Counter": counter,
                  "Date": ymdDate,
                  "timeStamp": timeStamp,
                  "DataOutputs": DataOutputs || "No DataOutputs"
              });

    } else {
      console.log('log', DataOutputs, uid,  "users",  uid, "actions", actionId);
        docRef = await setDoc(doc(db, "users",  uid, "actions", actionId), {
    //  docRef = await addDoc(collection(db, 'users',uid), {
            "IP": userIp || "No IP", // default to "No IP" if userIp is undefined
            "name": name || "No Name", // default to "No Name" if name is undefined
            "value": valueCleaned,
            "Counter": counter,
            "Date": ymdDate,
            "timeStamp": timeStamp,
            "DataOutputs": DataOutputs
        });
    }
    console.log("Document written with ID: ",uid, docRef);


    

    // // database.update(jsonUpdate);
    counter++;

    

    
    // logParamReal(name, valueCleaned, userIp, ymdDate, timeStamp, DataOutputs);
}

// export default asyncLogParams;
// export each functions
export {asyncLogParams, uploadBlobToStorage, restoreConfigFromFirebase, getImageFromFirebaseStorage};
